// TODO download modules ///////////////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Nav, Spinner, Alert } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

// TODO custom modules /////////////////////////////////////////////////////////////////////////////////////////////////

import * as constants from "./constants";
import * as utils from "./utils";
import * as actions from "./actions";

// TODO base ///////////////////////////////////////////////////////////////////////////////////////////////////////////

// Человекочитаемое название группы доступа для шапки — group_model хранит
// технические слаги ("user", "superuser" и т.п.), а не подпись для UI.
export const GroupLabel = (groupModel) => {
  if (!groupModel || !groupModel.length) return "Гость";
  if (groupModel.includes("superuser")) return "Администратор";
  const map = {
    moderator: "Модератор",
    buhgalteria: "Бухгалтерия",
    sup: "Отдел кадров",
    user: "Сотрудник",
  };
  for (let g of groupModel) {
    if (map[g]) return map[g];
  }
  return groupModel[0];
};

export const HeaderComponent = () => {
  // TODO react hooks variables ////////////////////////////////////////////////////////////////////////////////////////

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // TODO custom variables /////////////////////////////////////////////////////////////////////////////////////////////

  const { title, description, logic, redirect } = utils.GetInfoPage(
    location.pathname
  );

  const [firstRefreshUserDetails, firstRefreshUserDetailsSet] = useState(true);
  const [firstRefreshNotification, firstRefreshNotificationSet] =
    useState(true);

  // открытый в данный момент модуль (аккордеон в сайдбаре)
  const [openModule, openModuleSet] = useState(null);
  // мобильный сайдбар открыт/закрыт
  const [mobileOpen, mobileOpenSet] = useState(false);

  // TODO react store variables ////////////////////////////////////////////////////////////////////////////////////////

  const userLoginStore = useSelector((state) => state.userLoginStore);
  const {
    // load: loadUserLogin,
    data: dataUserLogin,
    // error: errorUserLogin,
    // fail: failUserLogin,
  } = userLoginStore;
  //////////////////////////////////////////////////////////
  const userDetailStore = useSelector((state) => state.userDetailStore);
  const {
    // load: loadUserDetail,
    data: dataUserDetail,
    // error: errorUserDetail,
    // fail: failUserDetail,
  } = userDetailStore;
  //////////////////////////////////////////////////////////
  const notificationListStore = useSelector(
    (state) => state.notificationListStore
  );
  const {
    // load: loadNotificationList,
    data: dataNotificationList,
    // error: errorNotificationList,
    // fail: failNotificationList,
  } = notificationListStore;

  // TODO useEffect hooks //////////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (!dataUserDetail) {
      const form = {
        "Action-type": "USER_DETAIL",
      };
      dispatch(
        utils.ActionConstructorUtility(
          form,
          "/api/auth/user/detail/",
          "POST",
          30000,
          constants.USER_DETAIL,
          true
        )
      );
    } else {
      if (logic && firstRefreshUserDetails) {
        firstRefreshUserDetailsSet(false);
        dispatch({ type: constants.USER_DETAIL.reset });
      }
      if (
        redirect &&
        !utils.CheckPageAccess(userDetailStore, location.pathname)
      ) {
        navigate("/");
      }
    }
  }, [
    dataUserDetail,
    dispatch,
    firstRefreshUserDetails,
    logic,
    location.pathname,
    redirect,
    navigate,
  ]);
  //////////////////////////////////////////////////////////
  useEffect(() => {
    if (logic) {
      if (dataUserLogin == null && location.pathname !== "/login" && redirect) {
        utils.Sleep(10).then(() => {
          if (
            dataUserLogin == null &&
            location.pathname !== "/login" &&
            redirect
          ) {
            dispatch(actions.userLogoutAction());
            navigate("/login");
          }
        });
      } else {
        if (dataUserDetail && dataUserDetail["user_model"]) {
          if (
            dataUserDetail["user_model"]["activity_boolean_field"] === false
          ) {
            dispatch(actions.userLogoutAction());
            navigate("/login");
          }
          if (
            !dataUserDetail["user_model"]["secret_question_char_field"] ||
            !dataUserDetail["user_model"]["secret_answer_char_field"]
          ) {
            navigate("/change_profile");
          }
        }
      }
    }
  }, [logic, location.pathname, redirect, dispatch, navigate]);
  //////////////////////////////////////////////////////////
  useEffect(() => {
    if (!dataNotificationList) {
      const form = {
        "Action-type": "",
      };
      dispatch(
        utils.ActionConstructorUtility(
          form,
          `/api/auth/user/notification/?page=${1}&limit=${-1}`,
          "GET",
          30000,
          constants.NOTIFICATION_LIST
        )
      );
    } else {
      if (firstRefreshNotification) {
        firstRefreshNotificationSet(false);
        dispatch({ type: constants.NOTIFICATION_LIST.reset });
      }
    }
  }, [dispatch, firstRefreshNotification]);
  //////////////////////////////////////////////////////////
  // автоматически открыть модуль, соответствующий текущей странице
  useEffect(() => {
    for (let module of constants.modules) {
      for (let section of module.Sections) {
        for (let link of section.Links) {
          if (
            !link.ExternalLink &&
            link.Link.split("/")[1] === location.pathname.split("/")[1] &&
            location.pathname !== "/"
          ) {
            openModuleSet(module.Header);
            return;
          }
        }
      }
    }
  }, [location.pathname]);

  const notificationCount =
    dataNotificationList && dataNotificationList.data
      ? dataNotificationList.data.length
      : 0;

  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      {/* верхняя полоса для мобильных экранов — открывает сайдбар */}
      <div className="km-mobile-bar">
        <a href="/" className="d-flex align-items-center text-decoration-none">
          <img src="/static/img/logo.svg" alt="КМ" />
        </a>
        <button
          className="km-mobile-toggle"
          onClick={() => mobileOpenSet(!mobileOpen)}
        >
          <i className="fa-solid fa-bars" />
        </button>
      </div>

      <aside className={`km-sidebar ${mobileOpen ? "km-open" : ""}`}>
        <a href="/" className="km-brand">
          <img src="/static/img/logo.svg" alt="Костанайские минералы" />
          <span className="km-brand-name">
            Костанайские
            <br />
            Минералы
          </span>
        </a>

        <div className="km-nav-group">
          <Link
            to="/"
            className="km-nav-link"
            style={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}
            onClick={() => mobileOpenSet(false)}
          >
            <span className="km-nav-icon">
              <i className="fa-solid fa-house" />
            </span>
            Домашняя
            {notificationCount > 0 && (
              <span className="badge-count">{notificationCount}</span>
            )}
          </Link>
        </div>

        {constants.modules.map(
          (module, module_i) =>
            utils.CheckAccess(userDetailStore, module.Access) && (
              <div className="km-nav-group" key={module_i}>
                <div
                  className={`km-nav-item ${
                    openModule === module.Header ? "open" : ""
                  }`}
                >
                  <button
                    className="km-nav-toggle"
                    onClick={() =>
                      openModuleSet(
                        openModule === module.Header ? null : module.Header
                      )
                    }
                  >
                    <span className="km-nav-icon">
                      <i className={utils.ModuleIcon(module.Header)} />
                    </span>
                    {module.Header}
                    {module.Header === "Профиль" && notificationCount > 0 && (
                      <span className="badge-count">{notificationCount}</span>
                    )}
                    <span className="km-nav-chevron">
                      <i className="fa-solid fa-chevron-right" />
                    </span>
                  </button>

                  {openModule === module.Header && (
                    <div className="km-nav-sections">
                      {module.Sections.map(
                        (section, section_i) =>
                          utils.CheckAccess(
                            userDetailStore,
                            section.Access
                          ) && (
                            <div key={section_i}>
                              <div className="km-nav-section-label">
                                {section.Header}
                              </div>
                              {section.Links.map((link, link_i) =>
                                link.ExternalLink
                                  ? utils.CheckAccess(
                                      userDetailStore,
                                      link.Access
                                    ) && (
                                      <a
                                        key={link_i}
                                        className={`km-nav-link ${
                                          !link.Active ? "disabled" : ""
                                        }`}
                                        href={link.Link}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <span className="km-nav-icon">
                                          <i className={link.LinkIcon} />
                                        </span>
                                        {link.Header}
                                      </a>
                                    )
                                  : utils.CheckAccess(
                                      userDetailStore,
                                      link.Access
                                    ) &&
                                    link.ShowLink && (
                                      <Link
                                        key={link_i}
                                        to={link.Link}
                                        className={`km-nav-link ${
                                          !link.Active ? "disabled" : ""
                                        }`}
                                        onClick={() => mobileOpenSet(false)}
                                      >
                                        <span className="km-nav-icon">
                                          <i className={link.LinkIcon} />
                                        </span>
                                        {link.Header}
                                        {link.Header === "Уведомления" &&
                                          notificationCount > 0 && (
                                            <span className="badge-count">
                                              {notificationCount}
                                            </span>
                                          )}
                                      </Link>
                                    )
                              )}
                            </div>
                          )
                      )}
                    </div>
                  )}
                </div>
              </div>
            )
        )}

        <div className="km-sidebar-foot">
          {dataUserLogin ? (
            <Link to="/logout" className="km-logout-btn">
              <i className="fa-solid fa-door-open" />
              Выйти
            </Link>
          ) : (
            <Link to="/login" className="km-login-btn">
              <i className="fa-solid fa-arrow-right-to-bracket" />
              Войти
            </Link>
          )}
        </div>
      </aside>

      {dataUserLogin && (
        <div className="km-topbar">
          <div className="km-topbar-greeting">
            Добро пожаловать
            {dataUserDetail &&
              dataUserDetail["user_model"] &&
              (dataUserDetail["user_model"]["first_name_char_field"] ||
                dataUserDetail["user_model"]["last_name_char_field"]) && (
                <>
                  ,{" "}
                  <b>
                    {dataUserDetail["user_model"]["first_name_char_field"]}{" "}
                    {dataUserDetail["user_model"]["last_name_char_field"]}
                  </b>
                </>
              )}
            <span className="km-topbar-date">
              {" "}
              · {new Date().toLocaleDateString("ru-RU", {
                weekday: "long",
                day: "numeric",
                month: "long",
              })}
            </span>
          </div>
          <Link to="/change_profile" className="km-user-chip">
            <span className="km-avatar">
              {dataUserDetail &&
              dataUserDetail["user_model"] &&
              (dataUserDetail["user_model"]["first_name_char_field"] ||
                dataUserDetail["user_model"]["last_name_char_field"])
                ? `${(
                    dataUserDetail["user_model"]["first_name_char_field"] || ""
                  ).charAt(0)}${(
                    dataUserDetail["user_model"]["last_name_char_field"] || ""
                  ).charAt(0)}`
                : <i className="fa-solid fa-user" />}
            </span>
            <span>
              {dataUserDetail &&
              dataUserDetail["user_model"] &&
              (dataUserDetail["user_model"]["first_name_char_field"] ||
                dataUserDetail["user_model"]["last_name_char_field"])
                ? `${dataUserDetail["user_model"]["last_name_char_field"] || ""} ${
                    dataUserDetail["user_model"]["first_name_char_field"] || ""
                  }`
                : dataUserDetail && dataUserDetail["user_model"]
                ? GroupLabel(dataUserDetail["user_model"]["group_model"])
                : GroupLabel(null)}
            </span>
          </Link>
        </div>
      )}

      {title !== "" && description !== "" && location.pathname !== "/" && (
        <div className="km-page-head">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      )}
    </>
  );
};

export const FooterComponent = () => {
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <footer className="km-footer">
      <div className="km-footer-grid">
        <div className="km-footer-col">
          <h6>Сайты</h6>
          <a href="https://km.kz/" target="_blank" rel="noreferrer">KM KZ</a>
          <a href="https://www.km-open.online/" target="_blank" rel="noreferrer">KM OPEN</a>
          <a href="https://web.cplus.kz/" target="_blank" rel="noreferrer">KM QR</a>
        </div>
        <div className="km-footer-col">
          <h6>Соцсети</h6>
          <a href="https://www.instagram.com/kostanay_minerals/?igshid=smmei29dpn8h" target="_blank" rel="noreferrer">Instagram</a>
          <a href="https://www.facebook.com/kostmineral/" target="_blank" rel="noreferrer">Facebook</a>
          <a href="https://t.me/kostanayminerals" target="_blank" rel="noreferrer">Telegram</a>
          <a href="https://www.youtube.com/watch?v=GT9q0WWGH44&ab_channel=%D0%9A%D0%BE%D1%81%D1%82%D0%B0%D0%BD%D0%B0%D0%B9%D1%81%D0%BA%D0%B8%D0%B5%D0%9C%D0%B8%D0%BD%D0%B5%D1%80%D0%B0%D0%BB%D1%8B" target="_blank" rel="noreferrer">YouTube</a>
        </div>
        <div className="km-footer-col">
          <h6>Газета «Хризотил»</h6>
          <a href="https://www.instagram.com/gazetakm/" target="_blank" rel="noreferrer">Instagram</a>
          <a href="https://chrysotile.kz/" target="_blank" rel="noreferrer">Сайт газеты</a>
        </div>
        <div className="km-footer-col">
          <h6>Контакты</h6>
          <address>
            110700, Республика Казахстан,
            <br />
            Костанайская область, г. Житикара,
            <br />
            ул. Ленина, 67
            <br />
            <br />
            Тел/факс: 8 (714 35) 2-40-30
            <br />
            info@km.kz
            <br />
            <br />
            Сброс пароля: 10-20 / 10-21
            <br />
            Работоспособность платформы: 10-22
          </address>
        </div>
      </div>
      <div className="km-footer-bottom">
        © {new Date().getFullYear()} АО «Костанайские Минералы» · Внутренняя
        веб-платформа
      </div>
    </footer>
  );
};

// TODO components /////////////////////////////////////////////////////////////////////////////////////////////////////

export const ModulesComponent = () => {
  // TODO react store variables ////////////////////////////////////////////////////////////////////////////////////////
  const userDetailStore = useSelector((state) => state.userDetailStore);
  //////////////////////////////////////////////////////////
  const notificationListStore = useSelector(
    (state) => state.notificationListStore
  );
  const {
    // load: loadNotificationList,
    data: dataNotificationList,
    // error: errorNotificationList,
    // fail: failNotificationList,
  } = notificationListStore;
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="shadow text-center m-0 p-0">
      {constants.modules && (
        <div className="m-0 p-0">
          <h6 className="display-6 text-center card-header bg-light bg-opacity-100 m-0 p-1">
            Модули:
          </h6>
          <div className="m-0 p-0">
            <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 m-0 p-0">
              {constants.modules.map(
                (module, module_i) =>
                  utils.CheckAccess(userDetailStore, module.Access) &&
                  module.ShowInModules && (
                    <div key={module_i} className="text-center m-0 p-1">
                      <div className="lead card-header border shadow bg-light bg-opacity-100 custom-background-transparent-hard m-0 p-0">
                        {module["Header"]}
                      </div>
                      <div className="text-center custom-background-transparent-middle m-0 p-0">
                        <img
                          src={module["Image"]}
                          className="img-fluid w-25 m-0 p-0"
                          alt="id"
                        />
                      </div>
                      {module["Sections"]
                        ? module["Sections"].map(
                            (section, section_i) =>
                              utils.CheckAccess(
                                userDetailStore,
                                section.Access
                              ) && (
                                <div
                                  key={section_i}
                                  className="card-body text-end m-0 p-0"
                                >
                                  <div className="card">
                                    <li className="list-group-item list-group-item-action active disabled bg-primary bg-opacity-75 d-flex m-0 p-1">
                                      <div className="m-0 p-0">
                                        <img
                                          src={section["Image"]}
                                          className="img-fluid w-25 m-0 p-0"
                                          alt="id"
                                        />
                                      </div>
                                      <LinkContainer
                                        to="#"
                                        className="disabled m-0 p-3"
                                      >
                                        <Nav.Link>
                                          <small className="fw-bold text-light m-0 p-0">
                                            {section["Header"]}
                                          </small>
                                        </Nav.Link>
                                      </LinkContainer>
                                    </li>
                                    <ul className="list-group-flush m-0 p-0">
                                      {section["Links"]
                                        ? section["Links"].map((link, link_i) =>
                                            link["Active"]
                                              ? utils.CheckAccess(
                                                  userDetailStore,
                                                  link.Access
                                                ) &&
                                                link.ShowLink && (
                                                  <li
                                                    key={link_i}
                                                    className="list-group-item list-group-item-action m-0 p-0"
                                                  >
                                                    {link.ExternalLink ? (
                                                      <a
                                                        key={link_i}
                                                        className={
                                                          link["Active"]
                                                            ? "text-dark dropdown-item m-0 p-0"
                                                            : "disabled m-0 p-1"
                                                        }
                                                        href={link["Link"]}
                                                        target="_self"
                                                      >
                                                        <i
                                                          className={
                                                            link.LinkIcon
                                                          }
                                                        />
                                                        {link["Header"]}
                                                      </a>
                                                    ) : (
                                                      <LinkContainer
                                                        to={link["Link"]}
                                                      >
                                                        <Nav.Link className="m-0 p-1">
                                                          <small
                                                            className={
                                                              link.Style !== ""
                                                                ? `${link.Style} m-0 p-1`
                                                                : "text-dark m-0 p-1"
                                                            }
                                                          >
                                                            <i
                                                              className={
                                                                link.LinkIcon
                                                              }
                                                            />
                                                            {link["Header"]}
                                                            {"  "}
                                                            {link.Header ===
                                                              "Уведомления" &&
                                                              dataNotificationList &&
                                                              dataNotificationList
                                                                .data.length >
                                                                0 && (
                                                                <span className="badge rounded-pill text-danger m-0 p-1">
                                                                  <i className="fa-solid fa-bell text-danger m-0 p-1" />
                                                                  {
                                                                    dataNotificationList
                                                                      .data
                                                                      .length
                                                                  }
                                                                </span>
                                                              )}
                                                          </small>
                                                        </Nav.Link>
                                                      </LinkContainer>
                                                    )}
                                                  </li>
                                                )
                                              : utils.CheckAccess(
                                                  userDetailStore,
                                                  link.Access
                                                ) &&
                                                link.ShowLink && (
                                                  <li
                                                    key={link_i}
                                                    className="list-group-item list-group-item-action disabled m-0 p-0"
                                                  >
                                                    <LinkContainer
                                                      to={
                                                        link["Link"]
                                                          ? link["Link"]
                                                          : "#"
                                                      }
                                                      className="disabled m-0 p-0"
                                                    >
                                                      <Nav.Link>
                                                        <small className="text-muted m-0 p-0">
                                                          {link["Header"]} (
                                                          <small className="text-danger m-0 p-0">
                                                            В РАЗРАБОТКЕ
                                                          </small>
                                                          )
                                                        </small>
                                                      </Nav.Link>
                                                    </LinkContainer>
                                                  </li>
                                                )
                                          )
                                        : ""}
                                    </ul>
                                  </div>
                                </div>
                              )
                          )
                        : ""}
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Цвет и иконка карточки ленты по ссылке раздела — позволяет визуально
// различать категории новостей без изменения структуры constants.news.
const NewsCardStyle = (link) => {
  const map = {
    "/rational_reglam": { color: "violet", icon: "fa-solid fa-lightbulb" },
    "/idea_reglam": { color: "green", icon: "fa-solid fa-bank" },
    "/video_study": { color: "cyan", icon: "fa-solid fa-clapperboard" },
    "/vacation": { color: "amber", icon: "fa-solid fa-umbrella-beach" },
    "/servicerecord": { color: "blue", icon: "fa-solid fa-id-card-clip" },
    "/salary": { color: "red", icon: "fa-solid fa-file-invoice-dollar" },
  };
  return map[link] || { color: "grey", icon: "fa-solid fa-circle-info" };
};

export const NewsComponent = ({ count = 100 }) => {
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="m-0 p-0">
      <div className="d-flex align-items-center justify-content-between m-0 p-0 mb-2 px-1">
        <h2 style={{ fontSize: "17px", fontWeight: 700, margin: 0 }}>
          <i className="fa-solid fa-bolt text-warning m-0 p-1" />
          Лента изменений
        </h2>
        {count !== 100 && (
          <Link
            to="/news"
            style={{ fontSize: "12.5px", fontWeight: 600, color: "var(--km-blue)" }}
          >
            Все обновления →
          </Link>
        )}
      </div>
      <div className="d-flex flex-column gap-2 m-0 p-0">
        {constants.news.slice(0, count).map((news_elem, index) => {
          const style = NewsCardStyle(news_elem.Link);
          return (
            <Link
              key={index}
              to={news_elem.Link}
              className={`km-feed-card km-c-${
                news_elem.Status !== "active" ? "grey" : style.color
              }`}
            >
              <div className="km-feed-stripe" />
              <div className="km-ico">
                <i className={style.icon} />
              </div>
              <div className="km-feed-body">
                <div className="km-feed-top">
                  <div className="km-feed-title">{news_elem.Title}</div>
                  {news_elem.Status !== "active" ? (
                    <span className="km-status draft">
                      <span className="d" /> В разработке
                    </span>
                  ) : (
                    <span className="km-status done">
                      <span className="d" /> Готово
                    </span>
                  )}
                </div>
                <div className="km-feed-desc">
                  {news_elem.Description}
                  {news_elem.Helps && <> ({news_elem.Helps})</>}
                  {news_elem.Danger && (
                    <span className="note"> {news_elem.Danger}</span>
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export const StoreStatusComponent = ({
  storeStatus,
  keyStatus = "StoreStatus",
  consoleLog = false,
  showLoad = true,
  loadText = "",
  showData = true,
  dataText = "",
  showError = true,
  errorText = "",
  showFail = true,
  failText = "",
}) => {
  /////////////////////////////////////////////////////////////////////////////////////////////////TODO react components
  const {
    load: loadStatus,
    data: dataStatus,
    error: errorStatus,
    fail: failStatus,
  } = storeStatus;
  if (consoleLog) {
    console.log(`${keyStatus}`, storeStatus);
  }
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div key={keyStatus} className="m-0 p-0">
      {showLoad && loadStatus && (
        <div className="row justify-content-center m-0 p-0">
          {loadText !== "" ? (
            <Alert variant={"secondary"} className="text-center m-0 p-1">
              {loadText}
            </Alert>
          ) : (
            <Spinner
              animation="border"
              role="status"
              style={{
                height: "50px",
                width: "50px",
                margin: "auto",
                display: "block",
              }}
              className="text-center m-0 p-0"
            >
              <small className="m-0 p-0">ждите</small>
              <span className="sr-only m-0 p-0" />
            </Spinner>
          )}
        </div>
      )}
      {showData && dataStatus && (
        <div className="row justify-content-center m-0 p-0">
          <Alert variant={"success"} className="text-center m-0 p-1">
            {dataText !== "" ? dataText : dataStatus}
          </Alert>
        </div>
      )}
      {showError && errorStatus && (
        <div className="row justify-content-center m-0 p-0">
          <Alert variant={"danger"} className="text-center m-0 p-1">
            {errorText !== "" ? errorText : errorStatus}
          </Alert>
        </div>
      )}
      {showFail && failStatus && (
        <div className="row justify-content-center m-0 p-0">
          <Alert variant={"warning"} className="text-center m-0 p-1">
            {failText !== "" ? failText : failStatus}
          </Alert>
        </div>
      )}
    </div>
  );
};

export const MessageComponent = ({ variant, children }) => {
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="row justify-content-center m-0 p-1">
      <Alert variant={variant} className="text-center m-0 p-1">
        {children}
      </Alert>
    </div>
  );
};

export const LoaderComponent = () => {
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <Spinner
      animation="border"
      role="status"
      style={{
        height: "50px",
        width: "50px",
        margin: "auto",
        display: "block",
      }}
    >
      ЖДИТЕ<span className="sr-only">ЖДИТЕ</span>
    </Spinner>
  );
};

export const AccordionComponent = ({
  key_target,
  isCollapse = true,
  title,
  text_style = "text-danger",
  header_style = "bg-danger bg-opacity-10",
  body_style = "bg-danger bg-opacity-10",
  children,
}) => {
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="m-0 p-1">
      <div className="accordion m-0 p-0" id="accordionExample">
        <div className="accordion-item custom-background-transparent-middle m-0 p-0">
          <h2
            className="accordion-header custom-background-transparent-low m-0 p-0"
            id="accordion_heading_1"
          >
            <button
              className={`accordion-button m-0 p-0 ${header_style}`}
              type="button"
              data-bs-toggle=""
              data-bs-target={`#${key_target}`}
              aria-expanded="false"
              aria-controls={key_target}
              onClick={(e) => utils.ChangeAccordionCollapse([key_target])}
            >
              <h6 className={`lead m-0 p-3 ${text_style}`}>
                {title}{" "}
                <small className="text-muted m-0 p-0">
                  (нажмите сюда, для переключения)
                </small>
              </h6>
            </button>
          </h2>
          <div
            id={key_target}
            className={
              isCollapse
                ? "accordion-collapse collapse m-0 p-0"
                : "accordion-collapse m-0 p-0"
            }
            aria-labelledby={key_target}
            data-bs-parent="#accordionExample"
          >
            <div className={`accordion-body m-0 p-0 ${body_style}`}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// TODO custom /////////////////////////////////////////////////////////////////////////////////////////////////////////

export const SalaryTableComponent = ({ tab = {} }) => {
  let header = tab[0];
  let thead_array = [];
  for (let i in tab[1]["Fields"]) {
    if (
      tab[1]["Fields"][i] !== "ВсегоДни" &&
      tab[1]["Fields"][i] !== "ВсегоЧасы"
    ) {
      thead_array.push(tab[1]["Fields"][i]);
    }
  }
  let tbody_array = [];
  for (let i in tab[1]) {
    if (i !== "Fields") {
      let local_tbody_array = [];
      for (let j in tab[1][i]) {
        if (j !== "ВсегоДни" && j !== "ВсегоЧасы") {
          local_tbody_array.push(tab[1][i][j]);
        }
      }
      tbody_array.push(local_tbody_array);
    }
  }
  function getValue(value) {
    if (typeof value === "number") {
      return value.toFixed(2);
    } else {
      return value;
    }
  }
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <li className="col-12 col-md-6 col-lg-6 m-0 p-3 my-1">
      <h6 className="lead fw-bold bold m-0 p-0">{header.slice(2)}</h6>
      <table className="table table-sm table-condensed table-striped table-hover table-responsive table-responsive-sm table-bordered border-secondary small m-0 p-0">
        <thead className="m-0 p-0 mb-1">
          <tr className="m-0 p-0">
            {thead_array.map((thead, index_h) => (
              <th
                key={index_h}
                className={
                  index_h === 4
                    ? "text-center w-25 m-0 p-p-1"
                    : "text-center m-0 p-p-1"
                }
              >
                {thead}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="m-0 p-0">
          {tbody_array.map((tbody, index_i) => (
            <tr key={index_i} className="m-0 p-0">
              {tbody.slice(0, 1).map((body, index_j) => (
                <td key={index_j} className="text-start m-0 p-1">
                  {body}
                </td>
              ))}
              {tbody.slice(1, -1).map((body, index_j) => (
                <td key={index_j} className="text-end m-0 p-1">
                  {body ? body : ""}
                </td>
              ))}
              {tbody.slice(-1).map((body, index_j) => (
                <td
                  key={index_j}
                  className={
                    index_j === 0 ? "text-end m-0 p-0" : "text-end m-0 p-1"
                  }
                >
                  {body ? getValue(body) : ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </li>
  );
};
